<template>
  <div class="connect-container">
    <div class="container">
      <el-card class="main-container">
        <div class="main-header">
          <div class="main-header-left">
            <span>{{$t('connections1')}}</span>
          </div>
          <div class="main-header-right" :class="{'zh1':!isEn,'fr1':isFr,'cz1':isCz}">
            <img src="../../assets/back.png">
            <p @click="back">{{$t('home')}}</p>
          </div>
        </div>
        <hr class="small-hr">

        <div class="context apply" v-for="item in hcpApply" :id="item.uid">
          <img src="../../assets/Pro.png" class="hcptype">
          <img src="../../assets/User-1.png" class="applyImg">
          <p>{{item.username}}</p>
          <p>{{$t('fullName')}}: {{item.realname}}</p>
          <span class="applyTip">{{$t('t1105_request_to_view_your_data').replace('$1', item.username)}}</span>
          <div class="applyButton">
            <button  @click="open(0,$event)">{{$t('Deny')}}</button>
            <button @click="open(1,$event)">{{$t('Agree')}}</button>
          </div>
          <img  class="cancel" src="../../assets/cancel_black.png" @click="openDelete">
        </div>
        <div class="context apply" v-for="item in carerApply" :id="item.uid">
          <img src="../../assets/User-1.png"  class="applyImg">
          <p>{{item.username}}</p>
          <p>{{$t('fullName')}}: {{item.realname}}</p>
          <span class="applyTip">{{$t('t1105_request_to_view_your_data').replace('$1', item.username)}}</span>
          <div class="applyButton">
            <button  @click="open(0,$event)">{{$t('Deny')}}</button>
            <button @click="open(1,$event)">{{$t('Agree')}}</button>
          </div>
          <img  class="cancel" src="../../assets/cancel_black.png" @click="openDelete">
        </div>

        <div class="context" v-for="item in hcp" :id="item.uid">
          <img src="../../assets/Pro.png" class="hcptype">
          <img src="../../assets/User-1.png" >
          <p>{{item.username}}</p>
          <p>{{$t('fullName')}}: {{item.realname}}</p>
          <p>{{$t('Bio')}}: <span>{{item.motto}}</span></p>
           <img  class="cancel" src="../../assets/cancel_black.png" @click="openDelete">
        </div>
        <div class="context" v-for="item in carer" :id="item.uid">
            <img src="../../assets/User-1.png">
            <p>{{item.username}}</p>
            <p>{{$t('fullName')}}: {{item.realname}}</p>
            <p>{{$t('Bio')}}: <span>{{item.motto}}</span></p>
            <img  class="cancel" src="../../assets/cancel_black.png"  @click="openDelete">
        </div>
        <div class="context" v-for="item in oauth2" :id="item.name">
          <img v-if="item.name=='diasend'" src="../../assets/diasend.png">
          <img v-else src="../../assets/User-1.png">
          <p>{{item.name}}</p>
          <p></p>
          <!--<p>{{$t('fullName')}}: {{item.realname}}</p>
          <p>{{$t('Bio')}}: <span>{{item.motto}}</span></p>-->
          <img  class="cancel" src="../../assets/cancel_black.png"  @click="deleteAuth">
        </div>

        <p v-show="noMes" class="noMes">{{$t('noConnect')}}</p>
      </el-card>
      <div class="Hcp-footer">
      <span>
<!--        <a href="http://www.medtrum.com/index.php/abouts">{{ $t('contact us') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="!isEU" href="http://www.medtrum.com/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/privacy_policy.html">|  {{ $t('Privacy Policy') }} </a>-->
<!--           <a v-if="isEU" href="http://www.medtrum.co.uk/terms_of_use.html">|  {{ $t('Terms of Use') }} | </a>-->
          <a :href="contactURL">{{ $t('contact us') }} </a>
          <a :href="privacyURL">|  {{ $t('Privacy Policy') }} </a>
          <a :href="termsOfUseURL">|  {{ $t('Terms of Use') }} | </a>

         {{$t('copyright')}} <br/>
          <a v-show="isZh" target=_blank href="http://beian.miit.gov.cn/"> 沪ICP备08013753号-3  </a>
          <img v-show="isZh" src="/static/beian.png" />
          <a v-show="isZh" target=_blank href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502014155"> 沪公网安备 31011502014155号 </a>
      </span>
      </div>

      <!--operate对话框-->
      <el-dialog  :visible.sync="ChooseVisible" size="tiny" id="dialog-form2" :show-close="false" >
        <div slot="title" class="patientList-dialog-title">
          <span>{{$t('Warning')}}</span>
          <img src="../../assets/cancel.png" @click="cancel">
        </div>
        <div slot class="dialog-body">
          <p v-show="isA">{{$t('agreeConnect')}}</p>
          <p v-show="!isA">{{$t('denyConnect')}}</p>
        </div>

        <div slot="footer" class="dialog-footer">
          <button  v-show="isA" @click="agree" >{{$t('Agree')}}</button>
          <button  v-show="!isA" @click="reject">{{$t('Yes')}}</button>
          <button class="cancel1"  @click="cancel" >{{$t('Cancel')}}</button>
        </div>
      </el-dialog>

      <!--delete对话框-->
      <el-dialog  :visible.sync="ChooseVisible2" size="tiny" id="dialog-form3" :show-close="false" >
        <div slot="title" class="patientList-dialog-title">
          <span>{{$t('Warning')}}</span>
          <img src="../../assets/cancel.png" @click="cancel">
        </div>
        <div slot class="dialog-body">
          <p>{{$t('deleteConnect')}}</p>
        </div>

        <div slot="footer" class="dialog-footer">
          <button @click="delete1">{{$t('Delete')}}</button>
          <button class="cancel1"  @click="cancel" >{{$t('Cancel')}}</button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import auth from '../../auth/auth'
  export default{
      data(){
          return{
            ChooseVisible:false, isA:false, ChooseVisible2:false,isEn:false,isEs:false,isCz:false,
            hcp:[],hcpApply:[],carer:[],carerApply:[], uid:0,noMes:false,isFr:false,isZh:false,
            oauth2:[],flag:'delete_connection',oauth2_name:'',
            isEU:true,
            contactURL:'',
            privacyURL:'',
            termsOfUseURL:''
          }
      },
      computed:{
        updateLocCode(){
          console.log('compute updateLocCode:');
          return this.$store.state.loc_code;
        }
      },
      watch:{
        updateLocCode(val){
          // this.$i18n.locale = val;
          console.log('watch updateLocCode:', val);
          let host=auth.getOuterHost();
          this.contactURL = host+'/contact.html';
          this.privacyURL = host+'/privacy_policy.html';
          this.termsOfUseURL = host + '/terms_of_use.html';
        }
      },
      methods:{
          back(){
            this.$router.push('/monitor');
          },
          getConnections(){
            auth.getPatientConnections(this);
          },
        //打开对话框
         open(flag,e){
           this.ChooseVisible = true;
           if(e){this.uid = parseInt(e.target.parentNode.parentNode.id);}
           //console.log(this.uid);
           (flag===1)? this.isA=true: this.isA=false;
         },
         agree(){
           auth.addConnection(this,this.uid);
           this.ChooseVisible = false;
         },
         reject(){
          auth.rejectConnection(this,this.uid);
          // console.log(this.uid);
          this.ChooseVisible = false;
        },
        //删除确认框
        openDelete(e){
          this.flag='delete_connection';
          this.ChooseVisible2 = true;
          if(e){this.uid = parseInt(e.target.parentNode.id);}
        },
        deleteAuth(e){
          this.flag='delete_oauth2';
          console.log("deleteAuth:");
          this.ChooseVisible2 = true;
          if(e){
            this.oauth2_name = e.target.parentNode.id;
          }
        },
        delete1(e){
          if ('delete_connection'==this.flag){
            auth.deleteConnection(this,this.uid);
          } else if ('delete_oauth2'==this.flag){
            let param={'name': this.oauth2_name};
            this.$http.post('/api/v2.0/oauth2.0/authorize/cancel', param).then(function (res) {
              console.log('authorize.cancel:', res.body);
              if (0==res.body.error) {
                auth.getPatientConnections(this)
              }
            }, function (err) {

            })
          }
          this.ChooseVisible2 = false;
        },
        cancel(){
          this.ChooseVisible = false;
          this.ChooseVisible2 = false;
        },
      },
      mounted(){
        let lang = sessionStorage.getItem('language');
        this.isEn = (lang!=='zh'&&lang !=='hk')?true:false;
        this.isEs = (lang==='es')?true:false;
        this.isFr = (lang==='fr')?true:false;
        this.isZh = (lang==='zh')?true:false;
        this.isCz = (lang==='cz')?true:false;
        let countryIndex=localStorage.getItem('index');
        //console.info('countryIndex:'+countryIndex);
        if (1==countryIndex || 6==countryIndex || 14==countryIndex) {
          this.isEU=false;
        }
        auth.getPatientConnections(this);
        setTimeout(()=>{
          let host=auth.getOuterHost();
          this.contactURL = host+'/contact.html';
          this.privacyURL = host+'/privacy_policy.html';
          this.termsOfUseURL = host + '/terms_of_use.html';
        }, 50)
      },
  }
</script>

<style scoped>
  .connect-container{
    min-height:889px;
    width:100%;
    background-color:#fff;
  }
  .container{
    width:62%;
    margin:0 auto;
    background:#fafbfc;
    padding-top: 15px;
  }
  @media screen and (max-width: 1500px){
    .container{
      width:92%;
    }
  }
  .main-container{
    width:97%;
    height:830px;
    margin:0 auto;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#282828;
    border: none;
  }
  .main-header{
    width: 98%;
    margin:0 auto;
    height:20px;
    margin-bottom: 15px;
  }
  .main-header-left{
    float: left;
    height:20px;
    line-height: 20px;
    border-left: 2px solid #005dac;
  }
  .main-header-left span{
    margin-left:10px;
  }
  .main-header-right{
    float: right;
    width:70px;
    height:20px;
    line-height: 20px;
    margin-right: 1%;
  }
  .zh1{
    width: 60px;
  }
  .fr1{
    width: 90px;
  }
  .cz1{
    width: 80px;
  }
  .main-header-right img{
    display: block;
    margin-top: 5px;
    float: left;
  }
  .main-header-right p{
    float:right;
    color:#0082d2;
    margin-top: 2px;
    cursor: pointer;
  }
  .small-hr{
    background:#e6e8ea;
    width:98%;
    height:1px;
    margin:0 auto;
    border:none;
  }

  .context{
    width:28%;
    height: 120px;
    min-width: 280px;
    border:1px solid #646464;
    border-radius:6px;
    padding-top:25px;
    padding-left: 10px;
    padding-bottom: 25px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    float: left;
    position: relative;
    margin-bottom: 25px;
    margin-top: 25px;
    margin-right: 3%;
    position: relative;
    display: inline-block;
  }
  .apply{
    border:1px solid #ff3c3c;
  }
  .context img{
    width: 70px;
    height: 70px;
    margin-right: 5px;
    float: left;
  }
  .context .hcptype{
    width: 40px;
    height: 50px;
    margin-right: 20px;
    position: absolute;
    top:0;
    left:0;
  }
  .context p{
    margin-bottom: 8px;
  }
  .context span{
    color:#005dac;
  }
  .context .cancel{
    width: 12px;
    height:12px;
    position: absolute;
    top:12px;
    right: -10px;
    cursor: pointer;
    margin-right: 20px;
  }
  .context .applyButton{
    width: 100%;
    position: absolute;
    bottom: 25px;
    left: 80px;
  }
  .context button{
    border-radius:100px;
    width:30%;
    height:22px;
    background: transparent;
    margin-top: 10px;
    border:1px solid #a3a3a3;
    color: #282828;
    outline: none;
    cursor: pointer;
  }
  .context button:hover{
    background-image:linear-gradient(90deg, #42c3fd 0%, #55adf8 100%);
  }
  .apply .applyImg{
    margin-bottom: 20px;
    margin-top: 5px;
  }
  .context .applyTip{
    color: #000;
  }


  .noMes{
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#ff3c3c;
    margin-top: 20px;
    margin-left: 20px;
  }

  .Hcp-footer{
    font-family:HelveticaNeue;
    font-size:14px;
    color:rgba(120,120,120,0.90);
    letter-spacing:-0.34px;
    text-align:center;
    margin-top: 13px;
    margin-bottom: 10px;
  }
  .Hcp-footer a{
    color:rgba(120,120,120,0.90);
    text-decoration: none;
  }
  .Hcp-footer a:hover{
    color:#0090D3;
  }

  /*弹出框*/
  .patientList-dialog-title{
    float: left;
    background-image:linear-gradient(90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .patientList-dialog-title span{
    margin-left: 42px;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
  }
  .patientList-dialog-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }
.dialog-body{
    font-family:SFUIText-Regular;
    width:100%;
    margin-top: 35px;
    margin-bottom: 30px;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.35px;
    text-align:center;
  }
  .dialog-body p{
    width: 75%;
    margin: 0 auto;
    text-align: left;
  }
  .dialog-footer{
    width: 90%;
    margin:0 auto 15px;
  }
  .dialog-footer button{
    border-radius:100px;
    width:30%;
    height:26px;
    background: transparent;
    border:1px solid #a3a3a3;
    color: #282828;
    outline: none;
    cursor: pointer;
  }
  .dialog-footer .cancel1{
    margin-left: 15%;
    margin-right: 10%;
  }

</style>



// WEBPACK FOOTER //
// patient-connect.vue?77a54b50